module.exports = __webpack_public_path__ + "static/media/sg7tj93.9fc17223.png";